import React from 'react'

import {toAbsoluteUrl} from '../../helpers/AssetHelpers'
import SubHeader from '../../layout/components/SubHeader'
import { useNavigate } from 'react-router-dom'
function SmsBlast() {
    const navigate = useNavigate()
    const handleCreateNewCampaign = () => {
        navigate('/blast/create-sms')
    }
  return (
   <>
     <SubHeader title="Sms Blast" description={"Sms Communication"} >
            <div className="d-flex justify-content-end">
                <button className="btn btn-light-primary btn-sm" onClick={handleCreateNewCampaign}>Create New Campaign</button>
            </div>
        </SubHeader>
    <div className="row">
        <div className="col-3">
           
            <img src={toAbsoluteUrl('/media/illustrations/ecx/personal_text_re_vqj3.svg')} className='img-fluid p-5' />
             
        <div className="alert bg-light-warning d-flex flex-column flex-sm-row p-5 mb-10 mt-5">
        <span className="svg-icon svg-icon-2hx svg-icon-warning me-4 mb-5 mb-sm-0">
            <svg xmlns="XXXXXXXXXXXXXXXXXXXXXXXXXX" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.5" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                <rect x="11" y="14" width="7" height="2" rx="1" transform="rotate(-90 11 14)" fill="currentColor"></rect>
                <rect x="11" y="17" width="2" height="2" rx="1" transform="rotate(-90 11 17)" fill="currentColor"></rect>
            </svg>
        </span>
        <div className="d-flex flex-column text-warning pe-0 pe-sm-10">
            <h4 className="mb-1">Please read</h4>
            <span>Use this sms campaign to connect with patient. This campaign will send text messsage to all the selected patients who have cell phone number. It will send even if they have unsubscribed to your sms. </span>
        </div>
    </div>
        </div>
        <div className="col-9">
            <div className="card">
                <div className="card-body">
                <table className="table table-striped gy-7">
                    <thead>
                        <tr className='fw-bolder fs-6 text-gray-800'>
                        <th>Campaign</th>
                        <th>Created</th>
                        <th>Status</th>
                        <th>Total</th>
                        <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <div className="d-flex flex-column ps-4">
                                    <div className="text-dark text-hover-primary mb-1 fs-6">Moving Notice</div>
                                    <div className="text-muted fw-bold fs-7">Sent Moving Notice to All patient.</div>
                                </div>
                            </td>
                            <td>2024-01-20</td>
                            <td> <span className="badge badge-info">Inprogress</span></td>
                            <td>2000</td>
                            <td> <button className="btn btn-sm btn-secondary">More </button> </td>
                        </tr>
                        <tr>
                            <td>
                                <div className="d-flex flex-column ps-4">
                                    <div className="text-dark text-hover-primary mb-1 fs-6">Christmas Hours</div>
                                    <div className="text-muted fw-bold fs-7">Custom hours for the Christmas notify.</div>
                                </div>
                            </td>
                            <td>2024-01-20</td>
                            <td><span className="badge badge-success">Sent</span></td>
                            <td>2000</td>
                            <td> <button className="btn btn-sm btn-secondary">More </button> </td>
                        </tr>
                    </tbody>
                    </table>              
                </div>
            </div>
        </div>
    </div>
   </>
  )
}

export default SmsBlast